import { render, staticRenderFns } from "./MapProductSwitch.vue?vue&type=template&id=aa544240"
import script from "./MapProductSwitch.vue?vue&type=script&lang=js"
export * from "./MapProductSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports